import React, {ReactNode} from 'react';
import {Box, Typography} from "@mui/material"

interface SpecRowProps {
    label: string
    value: ReactNode
    mono?: boolean
    stacked?: boolean
}

function SpecRow({label, value, mono, stacked}: SpecRowProps) {
    const valueSx = {
        fontFamily: mono ? "monospace" : undefined,
        wordBreak: "break-word" as const,
        minWidth: 0,
    }

    if (stacked) {
        return (
            <Box sx={{minWidth: 0}}>
                <Typography variant="caption" color="text.secondary" sx={{display: "block", mb: 0.25}}>{label}</Typography>
                <Typography component="div" variant="body2" sx={valueSx}>{value}</Typography>
            </Box>
        )
    }

    return (
        <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 2, minWidth: 0}}>
            <Typography variant="body2" color="text.secondary" noWrap>{label}</Typography>
            <Typography component="div" variant="body2" sx={{...valueSx, textAlign: "right"}}>{value}</Typography>
        </Box>
    )
}

export default SpecRow;
